import { getLayout as getMaxWidthContainerLayout } from 'layouts/MaxWidthContainerLayout';
import { getLayout as getSiteOuterLayout } from 'layouts/SiteOuterLayout';
import { ArticlesBreadcrumb } from 'components/ArticlesBreadcrumb';
import { PageLayoutProps } from 'lib/shared/types/PageLayout';
import { ArticleMetaData } from 'lib/shared/types/ArticleMetaData';
import { Meta } from 'components/HeadContent';

export type ArticleLayoutProps = PageLayoutProps & { article: ArticleMetaData };

export const ArticleLayout = ({
  children,
  article: {
    data: { title, excerpt },
    seo,
  },
}: ArticleLayoutProps) => {
  return (
    <>
      <Meta titlePrefix={title} description={excerpt} seo={seo} />
      <ArticlesBreadcrumb />
      {children}
    </>
  );
};

export const getLayout = (page, pageProps) => {
  return getSiteOuterLayout(
    getMaxWidthContainerLayout(
      <ArticleLayout {...pageProps}>{page}</ArticleLayout>
    )
  );
};

ArticleLayout.getLayout = getLayout;
